import { render, staticRenderFns } from "./RootNode.vue?vue&type=template&id=5f3c2dc2&scoped=true"
import script from "./RootNode.vue?vue&type=script&lang=js"
export * from "./RootNode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c2dc2",
  null
  
)

export default component.exports